import {
  type INotification,
  type IOrderNotification
} from '@/types/INotification';

/**
 * Type guard варианта уведомления о заказе. Сужает обобщённый `INotification`
 * до `IOrderNotification` по дискриминатору `type` — для выбора рендерера
 * карточки заказа в тостах и панели.
 *
 * @param notification - обобщённое уведомление
 * @returns `true`, если уведомление имеет тип `order`
 */
export const isOrderNotification = (
  notification: INotification
): notification is IOrderNotification => notification.type === 'order';
